import React from 'react';
import { connect } from 'react-redux';

import gameKit from '../../../../GameKit';

import settings from '../../../../settings';

import SelectRow from './SelectRow';
import SideBarPageNav from '../SideBarPageNav';
import ActionReactionDropDownItem from './ActionReactionDropDownItemEnum';
import ReactWhen from './ReactWhen';
import Reaction from './Reaction';
import AfterReaction from './AfterReaction';

import { setOpenDropdownItem } from '../../../actions/actionReactionActions';

class ActionReaction extends React.Component {
    setOpenDropdownItem = item => {
        const { dispatch } = this.props;
        dispatch(setOpenDropdownItem(item));
    };

    updateBlokStateActionReaction = options => gameKit.levelEditor.blokEditor.updateBlokStateActionReaction(options);

    switchToActieReactieMode = mode => gameKit.levelEditor.blokEditor.switchToActieReactieMode(mode);

    selectActionReactionForward = () => gameKit.levelEditor.blokEditor.selectActionReactionForward();

    render() {
        const {
            closeSideBar,
            actionReaction,
            activeItem,
            setActiveItem,
            actionReactionAfterwards,
            blokEditor,
            defaultBlockUrl,
            defaultBlockHue,
            activeOtherBlockUrl,
            activeOtherBlockHue
        } = this.props;

        return (
            <>
                <SideBarPageNav
                    blokEditor={blokEditor}
                    setActiveItem={setActiveItem}
                    activeItem={activeItem}
                    actionReactionAfterwards={actionReactionAfterwards}
                    defaultBlockUrl={defaultBlockUrl}
                    defaultBlockHue={defaultBlockHue}
                />
                <div className="side-bar-header">
                    <div className="side-bar-header-col side-bar-header-text">Acties/Reacties</div>
                    <div className="side-bar-header-col side-bar-header-close" onClick={closeSideBar} role="none">
                        <img src={`${settings.assetsPath}img/icons/bouwsteen-sluit.png`} alt="Sluiten" title="Sluiten" />
                    </div>
                </div>
                <SelectRow
                    activeItem={actionReaction.openDropdownItem}
                    item={{
                        id: ActionReactionDropDownItem.REACT_WHEN,
                        title: 'Ik reageer als...',
                        icon: `${settings.assetsPath}img/icons/obj_switch_C1.png`,
                        iconStyle: { height: '42px', width: '42px', margin: '6px' },
                        onClick: id => this.setOpenDropdownItem(id),
                        component: (
                            <ReactWhen
                                respondToPlayerCollision={actionReaction.respondToPlayerCollision}
                                respondToObjectCollision={actionReaction.respondToObjectCollision}
                                updateBlokStateActionReaction={this.updateBlokStateActionReaction}
                            />
                        )
                    }}
                />
                <SelectRow
                    activeItem={actionReaction.openDropdownItem}
                    item={{
                        id: ActionReactionDropDownItem.REACTION,
                        title: '...dan doe ik',
                        icon: `${settings.assetsPath}img/icons/dan_doe_ik.png`,
                        iconStyle: { height: '48px', width: '72px' },
                        onClick: id => this.setOpenDropdownItem(id),
                        component: (
                            <Reaction
                                points={actionReaction.points}
                                health={actionReaction.health}
                                sound={actionReaction.sound}
                                toLevel={actionReaction.toLevel}
                                updateBlokStateActionReaction={this.updateBlokStateActionReaction}
                                selectActionReactionForward={this.selectActionReactionForward}
                            />
                        )
                    }}
                />
                <SelectRow
                    activeItem={actionReaction.openDropdownItem}
                    item={{
                        id: ActionReactionDropDownItem.AFTER_REACTION,
                        title: 'En daarna...',
                        icon: activeOtherBlockUrl || defaultBlockUrl,
                        iconStyle: {
                            borderRadius: '100%',
                            filter: `hue-rotate(${activeOtherBlockUrl ? activeOtherBlockHue : defaultBlockHue * -1}deg)`,
                            border: '1px solid black',
                            background: 'white'
                        },
                        onClick: id => this.setOpenDropdownItem(id),
                        component: <AfterReaction afterwards={actionReaction.afterwards} updateBlokStateActionReaction={this.updateBlokStateActionReaction} />
                    }}
                />
            </>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    actionReaction: state.actionReaction,
    blokEditor: state.blokEditor
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ActionReaction);
